/* GIST LIBRARY — inner pages: audio players + video embeds */
(function () {
  'use strict';

  function fmt(s) {
    s = Math.max(0, Math.floor(s || 0));
    return Math.floor(s / 60) + ':' + ('0' + (s % 60)).slice(-2);
  }

  /* Audio player: real <audio> when data-src is set, visual demo otherwise */
  function initPlayers(root) {
    (root || document).querySelectorAll('.gx-ap:not([data-gx-init])').forEach(function (ap) {
      ap.setAttribute('data-gx-init', '1');
      var wave = ap.querySelector('.gx-ap__wave');
      var btn = ap.querySelector('.gx-ap__btn');
      var time = ap.querySelector('.gx-ap__time');
      if (!wave || !btn) return;

      /* build waveform bars (pseudo-random, deterministic) */
      var bars = [];
      var seed = 7;
      for (var i = 0; i < 28; i++) {
        seed = (seed * 31 + 17) % 97;
        var b = document.createElement('i');
        b.style.height = (28 + (seed % 65)) + '%';
        wave.appendChild(b);
        bars.push(b);
      }

      var src = ap.getAttribute('data-src');
      var dur = parseFloat(ap.getAttribute('data-duration') || '90');
      var audio = null, demoTimer = null, demoPos = 0;
      if (time) time.textContent = '0:00 / ' + fmt(dur);

      function paint(p) {
        var onCount = Math.round(p * bars.length);
        bars.forEach(function (b, idx) { b.classList.toggle('on', idx < onCount); });
      }
      function setPlaying(on) { ap.classList.toggle('is-playing', on); }

      function stopDemo() { if (demoTimer) { clearInterval(demoTimer); demoTimer = null; } }

      btn.addEventListener('click', function () {
        if (src) {
          if (!audio) {
            audio = new Audio(src);
            audio.preload = 'metadata';
            audio.addEventListener('timeupdate', function () {
              var d = audio.duration || dur;
              paint(audio.currentTime / d);
              if (time) time.textContent = fmt(audio.currentTime) + ' / ' + fmt(d);
            });
            audio.addEventListener('ended', function () { setPlaying(false); paint(0); });
          }
          if (audio.paused) { document.querySelectorAll('audio').forEach(function(a){a.pause();}); audio.play(); setPlaying(true); }
          else { audio.pause(); setPlaying(false); }
        } else {
          /* demo mode — visual only */
          if (demoTimer) { stopDemo(); setPlaying(false); return; }
          setPlaying(true);
          demoTimer = setInterval(function () {
            demoPos += 0.35;
            if (demoPos >= dur) { demoPos = 0; stopDemo(); setPlaying(false); }
            paint(demoPos / dur);
            if (time) time.textContent = fmt(demoPos) + ' / ' + fmt(dur);
          }, 350);
        }
      });

      wave.addEventListener('click', function (ev) {
        var r = wave.getBoundingClientRect();
        var p = Math.min(1, Math.max(0, (ev.clientX - r.left) / r.width));
        if (src && audio) { audio.currentTime = p * (audio.duration || dur); }
        else { demoPos = p * dur; paint(p); if (time) time.textContent = fmt(demoPos) + ' / ' + fmt(dur); }
      });
    });
  }

  /* Video: swap poster for iframe embed on click (if data-embed set) */
  function initVideos(root) {
    (root || document).querySelectorAll('.gx-vid:not([data-gx-init])').forEach(function (v) {
      v.setAttribute('data-gx-init', '1');
      var embed = v.getAttribute('data-embed');
      if (!embed) return; /* pure mockup — no interaction */
      v.addEventListener('click', function () {
        if (v.querySelector('iframe')) return;
        var f = document.createElement('iframe');
        f.src = embed + (embed.indexOf('?') > -1 ? '&' : '?') + 'autoplay=1';
        f.allow = 'autoplay; encrypted-media; picture-in-picture';
        f.allowFullscreen = true;
        v.appendChild(f);
      }, { once: false });
    });
  }

  function initAll(root) { initPlayers(root); initVideos(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  else initAll(document);
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
